import { useEffect } from 'react';
import { INITIATE_USER_IMPERSONATION_EVENT, SIGN_IN_AS_GUID } from 'constants/AppConstants';
import { get } from 'lodash';

const useUserImpersonationEventListener = (initiateImpersonation) => {
  const handleUserImpersonationEvent = (event) => {
    const { detail } = event;
    const signInAsGuid = get(detail, SIGN_IN_AS_GUID, '');
    if (signInAsGuid) {
      initiateImpersonation(signInAsGuid);
    }
  };

  useEffect(() => {
    window.addEventListener(INITIATE_USER_IMPERSONATION_EVENT, handleUserImpersonationEvent);

    return () => {
      window.removeEventListener(INITIATE_USER_IMPERSONATION_EVENT, handleUserImpersonationEvent);
    };
  }, []);
};

export default useUserImpersonationEventListener;
